import {
  type ChatConversation,
  type ChatMessage,
  ContainmentOutcome,
  type SupportType,
  chatApi,
} from "@b2bportal/chat-api";
import type { IChatProvider } from "@b2bportal/core-chat";
import axios from "axios";

export const defaultChatProvider: IChatProvider = {
  chatTransferSource: "Voyager",
  async createConversation(
    supportType?: SupportType
  ): Promise<ChatConversation> {
    const res = await chatApi(axios).apiV0ChatbotCreatePut({ supportType });
    return res.data.conversation;
  },
  loadConversation(conversationId: string): Promise<ChatConversation> {
    throw new Error("Method not implemented.");
  },
  async closeConversation(conversationId: string) {
    await chatApi(axios).apiV0ChatbotClosePut({
      conversationId,
      containmentOutcome: ContainmentOutcome.Resolved,
    });
  },
  async sendMessage(
    conversationId: string,
    message: string
  ): Promise<ChatMessage> {
    const res = await chatApi(axios).apiV0ChatbotSendMessagePut({
      conversationId,
      message,
    });
    return res.data.message;
  },
};
